import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root'
})
export class TarefaService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

  listar(idUsuario, idProjeto, idParlamentar, idAgenda) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/tarefa/Listar?idUsuario=' + idUsuario + '&idProjeto=' + idProjeto)
        .subscribe(data => {
          resolve(data);
        }, error => {

        });
    });
  }
  
  alterar(tarefa) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/tarefa/Atualizar', tarefa)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
  
  remover(tarefa) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/tarefa/remover?IdTarefa=' + tarefa.Id)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }

  inserir(tarefa) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/tarefa/Inserir', tarefa)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
}
